import React, { FC } from 'react'
import { Badge } from '@wmgtech/legato'

import { CountryBadgeProps } from './CountryBadge.props'
import './CountryBadge.scss'

const CountryBadge: FC<CountryBadgeProps> = ({ text, onClear }) => {
  // TODO: Remove when Legato will have Badge onClick functionality
  const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if ((event.target as HTMLDivElement).classList.contains('lgt-icon')) {
      onClear(text)
    }
  }

  return (
    <div onClick={onClick}>
      <Badge text={text} icon iconName="xmark" colorType="dark" className="country_badge" size="sm" />
    </div>
  )
}

export default CountryBadge
